import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ActionCardComponent } from '../../atoms/cards/action-card/action-card.component';

@Component({
  selector: 'ui-alarms-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionCardComponent, TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <ui-action-card
        icon="bell"
        [items]="alarmsItems()"
        [label]="t('ALARMS.LABEL')"
        [iconClass]="
          (alarmsUnreadCount() ?? 0) > 0 || (alarmsActiveCount() ?? 0)
            ? 'text-error bg-error-light shadow-custom-error'
            : 'text-green bg-green-light shadow-custom-green'
        "
        (linkClick)="handleAlarmsLinkClick()"
      />
    </ng-container>
  `,
})
export class AlarmsCardComponent {
  private translocoService = inject(TranslocoService);

  alarmsUnreadCount = input<number | null>(null);
  alarmsActiveCount = input<number | null>(null);
  alarmsLinkClick = output<void>();
  activeLabel = toSignal(
    this.translocoService.selectTranslate('DISTRIBUTION_NETWORK.HEADER.ACTIVE'),
  );
  unreadLabel = toSignal(
    this.translocoService.selectTranslate('DISTRIBUTION_NETWORK.HEADER.UNREAD'),
  );

  alarmsItems = computed(() => [
    {
      label: this.activeLabel(),
      count: this.alarmsActiveCount(),
      class: this.getItemClasses(this.alarmsActiveCount()),
    },
    {
      label: this.unreadLabel(),
      count: this.alarmsUnreadCount(),
      class: this.getItemClasses(this.alarmsUnreadCount()),
    },
  ]);

  handleAlarmsLinkClick() {
    this.alarmsLinkClick.emit();
  }

  getItemClasses(count: number | null) {
    return (count ?? 0) <= 0 ? 'text-green' : 'text-error';
  }
}
